// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SecondaryLayout_wrapper__GF8ja"};